export { default } from './HeroMonthlyHistogramContainerMobile';
